import React, { useMemo } from 'react'
import { Box, BoxProps, styled } from '@mui/material'
import { useIsTablet } from '@src/hooks'

const HeaderNavMenu = styled(({ className, ...props }: BoxProps) => {
  const isTablet = useIsTablet()
  
  const classes = useMemo(() => {
    const res = [ className, 'HeaderNavMenu' ]
    return !isTablet ? [ ...res, '__desktop__' ] : res
  }, [ isTablet ])
  
  return <Box {...props} className={classes.join(' ')} />
})(
  ({ theme: { spacing, palette, transitions }}) => ({
    color: 'white',
    cursor: 'pointer',
    fontWeight: 400,
    padding: spacing(0.5, 1, 0.5, 1.5),
    fontSize: 14,
    position: 'absolute',
    right: 10,
    top: 'calc(50% - 17px)',
    borderRadius: spacing(0.5),
    overflow: 'hidden',
    height: 26,
    zIndex: 100,
    '&, .appHeaderNavMenu': {
      transition: transitions.create('all', {
        duration: 200,
        delay: 0
      }),
    },
    '.appHeaderNavMenu': {
      borderTop: '1px solid',
      margin: spacing(0.75, 0),
      paddingTop: spacing(0.75),
      opacity: 0,
      '.MuiButton-text': {
        textDecoration: 'none',
        justifyContent: 'start',
        width: '100%',
        '&:hover': {
          textDecoration: 'underline',
        }
      }
    },
    '&.__desktop__:hover, &.active': {
      backgroundColor: palette.primary.light,
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
      height: 63,
      '&, .appHeaderNavMenu': {
        transitionDelay: '100ms',
      },
      '.appHeaderNavMenu': {
        opacity: 1,
      }
    },
    '&&& .MuiButton-root': {
      color: 'inherit',
      textTransform: 'none',
      fontSize: 'inherit',
      padding: 0,
      minWidth: 0,
    }
  })
)

export default HeaderNavMenu